const erreurText = {
  message: "Oh non ! Cette page n'existe pas :(",
  link: "Revenir à la page d'accueil",
  tdb: "/tete2bite"
};

export default erreurText;
